export const enum CacheTypes {
  User = "user",
  Group = "group",
  Photo = "photo",
  GroupMember = "group-member",
  ShortVideo = "short-video",
  ShortThumbnail = "short-thumbnail",
}
